'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _isNumber = require('is-number');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _type = require('../type');

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var format = function format(value) {
  if (!value) return '';
  var formatted = ('' + value).replace(/[^a-zA-Z0-9]/gi, '').toUpperCase();
  return [].concat((0, _toConsumableArray3.default)(formatted)).reduce(function (combined, _char) {
    if ((0, _isNumber2.default)(_char)) combined.number = combined.number + 1;
    if ((0, _isNumber2.default)(_char) && combined.number > 3) return combined;
    return (0, _extends3.default)({}, combined, {
      string: '' + combined.string + _char
    });
  }, {
    string: '',
    number: 0
  }).string;
};

var validate = function validate(value) {
  if (!/^[A-Z0-9]+$/g.test(value)) return false;
  var numbers = ('' + value).replace(/[^0-9]/g, '');
  return numbers.length <= 3;
};

exports.default = (0, _type2.default)({
  type: 'string',
  format: format,
  validate: validate
});